import { HttpHandler } from 'msw'

import { theme } from './theme'

export const settings: HttpHandler[] = [...theme]
